import React from "react";
import Loader from "@hid-galaxy-ui/galaxy-react/components/Loader";
import { LoaderSizes } from "@hid-galaxy-ui/galaxy-react/components/Loader/loaderEnums";

const PageLoader = () => {
  return (
    <div className="hid-loader-full-page">
      <Loader variant={LoaderSizes.large} isOverlay />
    </div>
  );
};

export default PageLoader;
